import React from 'react';
import {Navigate} from 'react-router-dom';
import useIsLoggedIn, {useUserRole} from "../utils/userSessionUtils";

const ProtectedRoute = ({children, allowedRoles}) => {
    const isLoggedIn = useIsLoggedIn();
    const userRole = useUserRole();

    if (!isLoggedIn) {
        return <Navigate to="/login"/>;
    }

    if (allowedRoles !== "*" && !allowedRoles.includes(userRole)) {
        return <Navigate to="/"/>;
    }

    return children;
};

export default ProtectedRoute;
